import { createContext, useContext } from 'react';

export interface ContextualAiLayers {
    surfaceZIndex: number;
    transientZIndex: number;
    openTransient: () => void;
    closeTransient: () => void;
}

export const ContextualAiLayerContext = createContext<ContextualAiLayers | null>(null);
export const useContextualAiLayers = () => useContext(ContextualAiLayerContext);
